import { getBaseURL } from "@/contexts/auth/utils";

export const validId = (id: any) =>
  typeof id === "string" && id !== "null" && id !== "undefined";

export const parseBaseURL = (url: any) => {
  try {
    return new URL(url).origin;
  } catch {
    return "";
  }
};

/** Get the VAPID public key. */
export const VAPID_KEY = (() => {
  const backendUrl = getBaseURL();

  if (backendUrl === "https://dev.truthsocial.com") {
    return "BOwx3tIoDtmxDNiddRkryXnFzoe6vl2lxlWPvB6usn4RUUs7w9dojBQ2ANBQz8boNFvfRAs2F2eoUcNx7fdqiik=";
  } else {
    return "BB90KucI3YPKandew0b-kA4RQkBJMkRKA9_oIpRlhJjd024ayzmcqCzQ8AmZX1qXFkuqea2YRymHI9Atuc4tmf4=";
  }
})();
